import { Module } from 'vuex'
import { RootState } from '@/store'
import { mutations } from '@/store/modules/cart/mutations'
import { ICartState, initialState } from '@/store/modules/cart/state'

export * from '@/store/modules/cart/state'

export const store: Module<ICartState, RootState> = {
  state: initialState,
  mutations
}
